import React, { useState } from 'react';

import AiCommonModal from './AiCommonModal';
import AiQuestionSelection, { type IAiQuestionOption } from './AiCommonModal/AiQuestionSelection';

export type ShipmentServiceType = 'LTL' | 'FTL';

const OPTIONS: IAiQuestionOption[] = [
    { id: 'LTL', title: 'LTL', subtitle: 'Less Than Truckload' },
    { id: 'FTL', title: 'FTL', subtitle: 'Full Truckload' },
];

interface IProps {
    onSubmit: (value: ShipmentServiceType) => void;
    onClose: () => void;
}

const ServiceTypeSelectionCard = ({ onSubmit, onClose }: IProps) => {
    const [selected, setSelected] = useState<ShipmentServiceType>('LTL');

    const handleChange = (ids: (string | number)[]) => {
        const nextId = ids.find((id) => id !== selected);
        if (nextId !== undefined) setSelected(nextId as ShipmentServiceType);
    };

    return (
        <AiCommonModal title="What service type is this shipment?" agent="kate" handleClose={onClose} primaryBtnText="Submit" primaryBtnOnClick={() => onSubmit(selected)}>
            <AiQuestionSelection options={OPTIONS} selectedIds={[selected]} onChange={handleChange} orderedList />
        </AiCommonModal>
    );
};

export default ServiceTypeSelectionCard;
